(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/result/views/result.js') >= 0) return;  svs.modules.push('/modules/lotto/components/result/views/result.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.lotto=_svs.lotto||{};
_svs.lotto.components=_svs.lotto.components||{};
_svs.lotto.components.result=_svs.lotto.components.result||{};
_svs.lotto.components.result.templates=_svs.lotto.components.result.templates||{};
svs.lotto.components.result.templates.result = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"resultContentRegion\"></div>\n";
},"useData":true});
Handlebars.partials['svs-lotto-components-result-result'] = svs.lotto.components.result.templates.result;
})(svs, Handlebars);

 })(window);